export default __webpack_public_path__ + "static/media/Aura-Egg__32.0d7bea22.png";